import { Dimmer, Loader } from "semantic-ui-react";
import {
    useCreateVolumeAndCost,
    useDeleteVolumeAndCost,
    useGetVolumeAndCost,
    useUpdateVolumeAndCost
} from "../../../../api/volumeAndCost";
import { VolumeAndCost } from "../../../../components";
import { successMessage } from "../../../../helpers/ErrorHandler";

interface IngredientVolumeAndCostProps {
  ingredientId: string;
  supplierId: string;
  unitSize?: number;
  unitType?: string;
}

const IngredientVolumeAndCost = ({ ingredientId, supplierId, unitSize = 1, unitType = 'kg' }: IngredientVolumeAndCostProps) => {
  const { data: volumeAndCost, isLoading, refetch } = useGetVolumeAndCost(supplierId, ingredientId);
  const { mutate: createVolumeAndCost } = useCreateVolumeAndCost();
  const { mutate: updateVolumeAndCost } = useUpdateVolumeAndCost();
  const { mutate: deleteVolumeAndCost } = useDeleteVolumeAndCost();

  const addVolumeAndCostData = (data: any) => {
    const volumeAndCostData = {
      ...data,
      ownerId: supplierId,
      sourceId: ingredientId
    };
    createVolumeAndCost(volumeAndCostData, {
      onSuccess: () => {
        successMessage("Cost and volume recode are created")
        refetch();
      }
    });
  };

  const updateVolumeAndCostData = (data: any) => {
    const volumeAndCostData = {
      ...data,
      ownerId: supplierId,
      sourceId: ingredientId
    };
    updateVolumeAndCost(volumeAndCostData, {
      onSuccess: () => {
        refetch();
      }
    });
  };

  const deleteVolumeAndCostData = (volumeAndCostId: string) => {
    deleteVolumeAndCost(volumeAndCostId, {
      onSuccess: () => {
        refetch();
        successMessage("Volume and cost delete successfully");
      }
    });
  };

  //loading view
  if (isLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <VolumeAndCost
      volumeAndCost={volumeAndCost}
      addVolumeAndCostData={addVolumeAndCostData}
      updateVolumeAndCostData={updateVolumeAndCostData}
      deleteVolumeAndCostData={deleteVolumeAndCostData}
      unitSize={unitSize}
      unitType={unitType}
    />
  );
};

export default IngredientVolumeAndCost;
